export default __webpack_public_path__ + "static/gs-5-businessvalue--mobile-87d39c357b227dccdad25b14483a10fa.jpg";